import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Monitor, ArrowLeft } from 'lucide-react'

/**
 * Shown in place of the heavy visual/code editor on phones, where the
 * drag-canvas + code panels are not usable. Offers a way back and an
 * "open anyway" escape hatch for power users on a tablet-ish device.
 */
export default function EditorMobileNotice({ backTo = -1, backLabel = 'Go back', onOpenAnyway }) {
  const navigate = useNavigate()

  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '32px 24px',
        gap: 18,
        background: 'var(--bg-0)',
      }}
    >
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: 18,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--accent-soft)',
          color: 'var(--accent)',
        }}
      >
        <Monitor size={30} />
      </div>
      <div style={{ maxWidth: 360 }}>
        <h1 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text)', margin: '0 0 8px' }}>
          Best on a larger screen
        </h1>
        <p style={{ fontSize: 14, lineHeight: 1.5, color: 'var(--text-muted)', margin: 0 }}>
          The visual editor needs more room than a phone offers. Open it on a tablet or
          computer for the full drag-and-drop experience.
        </p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%', maxWidth: 280 }}>
        <button className="btn btn-primary" style={{ width: '100%', gap: 8 }} onClick={() => navigate(backTo)}>
          <ArrowLeft size={16} />
          {backLabel}
        </button>
        {onOpenAnyway && (
          <button className="btn btn-ghost btn-sm" style={{ width: '100%' }} onClick={onOpenAnyway}>
            Open editor anyway
          </button>
        )}
      </div>
    </div>
  )
}
